import { render, staticRenderFns } from "./PayPlayersPage.vue?vue&type=template&id=85ba07fe&scoped=true"
import script from "./PayPlayersPage.vue?vue&type=script&lang=js"
export * from "./PayPlayersPage.vue?vue&type=script&lang=js"
import style0 from "./PayPlayersPage.vue?vue&type=style&index=0&id=85ba07fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ba07fe",
  null
  
)

export default component.exports